/**
 *
 * CardData
 *
 */

import React, { memo } from 'react';

import { CardHorizontalLine, List } from './CardData.styles';

const CardData = (props) => <List {...props} />;

export default memo(CardData);

export { default as CardDataItem } from './CardDataItem';
export { default as CardLocationItem } from './CardLocationItem';
export { default as CardNoteItem } from './CardNoteItem';
export { default as CardDocumentItem } from './CardDocumentItem';
export { default as CardActivityLogItem } from './CardActivityLogItem';
export { CardHorizontalLine };
export { CardDataGrid } from './CardData.styles';
export { CardDataElements } from './CardData.styles';
export { ItemContentWrapper } from './CardData.styles';
